module.exports = __webpack_public_path__ + "static/media/lingswingchun-logo2.8762b4c8.jpg";